import React, { Fragment, useState } from 'react';
import ReactDOM from 'react-dom';
import Camera from './Camera';
import { InputFile } from "../appointments/create/store";
import { UploadImages } from "../appointments/create/api";
import { useEffect } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

//Update log
// FB 6039 DK  06/28/2022    Added for QR code scanning functionality
// FB 6347 GS  12/23/2022    removed max height and added padding to increase the QR code picture capturing screen size
// FB 6963 AS  06/09/2023    better error/success handling; renamed some fields for clarity
// FB 7264 DK   08/28/2023    Need an Admin Setting to Specify The Resolution of QR Camera Images

export default function Capturephotos(props: any) {

  const [inputList, setInputList] = useState<InputFile[]>([]);
  const [base64Img, setBase64Img] = useState("");
  const [capturedImage, setCapturedImage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");   //FB 6963
  const [errorMessage, setErrorMessage] = useState("");       //FB 6963

  useEffect(() => {
    async function upload() {
      if (base64Img != "") {
        var session_n = props.match.params.session_n;   		//FB 6963 renamed for clarity
        var control_name = props.match.params.control_name;		//FB 6963 renamed for clarity
        var licenceName = props.match.params.LicenceName;
        var token = props.match.params.tokenId;
        var currentdate = new Date();
        const input = {
          SESSION_N: session_n,		//FB 6963 renamed for clarity
          ImageId: Math.floor(new Date().getTime() / 1000),
          CONTROL_NAME: control_name,		//FB 6963 renamed for clarity
          Image: base64Img
        } as InputFile;
        try {
          const result = await UploadImages(input, token.slice(1, -1));

          setSuccessMessage("File uploaded successfully!");   // FB 6963 display success message on the page instead of alert

        } catch (err) {
          setErrorMessage(`There was an error while uploading the file(s): ${(err as Error).message}`);  // FB 6963 display error message
        }

      }

    }
    setSuccessMessage("");  //FB 6963 reset
    setErrorMessage("");    //FB 6963 reset
    upload();
  }, [base64Img]);

  const uploadImage = async (file: any) => {
    const formData = new FormData();
    formData.append("file", file);
  };


  return (
    <div className="App">
      <Grid container  >
        <Grid lg={12}
          md={12}
          sm={12} xs={12} style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            //FB 7264
            //paddingBottom: (window.innerWidth <= 768) ? "0px" : "120px", // FB  6347 added padding
          }}>
          <Typography variant="h6">
            Capture image from your camera!!
          </Typography>
          <br />
        </Grid>
        <Grid lg={12}
          md={12}
          sm={12} xs={12} style={{
            // FB  6347 removed max height
            alignItems: "center",
            justifyContent: "center"
          }}>
          <Camera sendFile={uploadImage} callBack={setBase64Img} successMessage={successMessage} errorMessage={errorMessage} /> {/* FB 6963 added success and error messages */}
        </Grid>
      </Grid>
    </div>
  );
}
